<div  class="loginPageBackground">
  <div class="padding-left-md padding-right-md">
    <img  class="logo padding-top-lg" src="/assets/img/fleetoperate_logo.jpg" width="300px" />
    <div class="padding-top-sm center"  >
      <h2 class="centerBoldedText">{{ title }}</h2>
      <span class="centerText"
        >{{ errorMessage || '' }}<br />
        @if (!isBerbixConflict) {
          <a href="mailto:support@fleetoperate.com">support&#64;fleetoperate.com</a>
          }</span
          >
        </div>

        <div  class="padding-top-lg" fxFlex>
          @if (isBerbixConflict) {
            <div class="btn-desc full-width">{{ btnDescription }}</div>
          }
          <button
            class="margin-bottom margin-top-xlg full-width"
            mat-raised-button
            color="primary"
            type="submit"
            (click)="onNavigateToSignIn()"
            >
            OK
          </button>
        </div>
      </div>
    </div>
